module.exports = { "default": require("core-js/library/fn/set"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/core-js/set.js
// module id = 116
// module chunks = 0